import { Color, DRAWER_COMPACT_WIDTH, rwd, Spacing } from '@billy/design-system'
import { useEffect } from 'react'

import type { VirtualAssistantChatPanelState } from '@features/virtualAssistant'

const EMBER_SQUEEZE_OFFSET = `calc(${DRAWER_COMPACT_WIDTH} + ${Spacing.S8})`

interface EmberViewSqueezeSyncProps {
  chatPanelState: VirtualAssistantChatPanelState
}

export const EmberViewSqueezeSync = ({ chatPanelState }: EmberViewSqueezeSyncProps): null => {
  const { isOpen, isExpanded } = chatPanelState
  useEffect(() => {
    const userMain = document.querySelector<HTMLElement>('.user-main')
    const userView = document.querySelector<HTMLElement>('.user-view')
    if (!userMain) {
      return
    }
    const mediaQuery = window.matchMedia(`(min-width: ${rwd.getBreakpointValue('xxxlarge')}px)`)
    const applyOffset = () => {
      const isCompact = isOpen && !isExpanded
      const shouldSqueeze = isCompact && mediaQuery.matches
      userMain.style.right = shouldSqueeze ? EMBER_SQUEEZE_OFFSET : '0px'
      userMain.style.clipPath = shouldSqueeze ? 'inset(0 0 0 0 round 0 16px 16px 0)' : ''
      if (userView) {
        userView.style.backgroundColor = shouldSqueeze ? Color.Grey100 : ''
      }
    }
    applyOffset()
    mediaQuery.addEventListener('change', applyOffset)
    return () => {
      mediaQuery.removeEventListener('change', applyOffset)
      userMain.style.right = ''
      userMain.style.clipPath = ''
      if (userView) {
        userView.style.backgroundColor = ''
      }
    }
  }, [isOpen, isExpanded])
  return null
}
